import styled from 'styled-components/macro'

export const StyledFiltersContainer = styled.div`
  height: auto;
  gap: 12px;
  position: absolute;
  right: ${({ isOpenRightModal }) => (isOpenRightModal ? '470px' : '14px')};
  top: 40px;
  transition: ${({ isOpenRightModal }) => (isOpenRightModal ? 'right 0.5s ease-in-out' : 'right 0.7s ease-in-out')};
  z-index: 400;
  overflow-y: scroll;
  scrollbar-width: none;
  ::-ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }

  // @media (max-width: 720px) {
  //   top: 40px;
  // }
`
